/* eslint-disable */

export default () => {

    const checkSearch = (search) => {
        return location.search.indexOf(search) > 0;
    }

    const blurEl = () => {
        setTimeout(() => {
            document.activeElement.blur();
        }, 1000);
    }

    window.addEventListener('load', () => {
        if(checkSearch('ed=1')) {
            document.querySelector('body').classList.add('editorial');

            if(checkSearch('hover')) {
                document.querySelectorAll('button, a, input, select').forEach(x => {
                    x.classList.add('hover');
                });
                document.querySelector('.preheader__rems-btn').click();
                document.querySelector('.nav__link.nav__link-btn').click();
                blurEl();

            }
            if(checkSearch('focus')) {
                document.querySelectorAll('button, a, input, select').forEach(x => {
                    x.classList.add('focus');
                });
            }
            //Cookies banner
            if (checkSearch('cookieBanner')) {
                setTimeout(() => {
                    document.querySelector('html').style.overflow = 'visible';
                    document.querySelector('body').style.overflow = 'visible';
                }, 5000);
                document.querySelector('body').classList.add('cookies');
            }
            if (checkSearch('cookieBannerHover')) {
                document.querySelector('body').classList.add('cookies-hover');
            }
            if (checkSearch('cookieBannerFocus')) {
                document.querySelector('body').classList.add('cookies-focus');
            }
            if (checkSearch('cookieBannerRejected')) {
                setTimeout(() => {
                    document.querySelectorAll('.ot-tgl input').forEach(e => {
                        e.click();
                    })
                }, 5000)
            }
            if (checkSearch('cookieBannerExpanded')) {
                document.querySelector('body').classList.add('cookies-expanded');
                setTimeout(() => {
                    document.querySelectorAll('button[ot-accordion="true"]').forEach(e => {
                        e.click();
                    })
                }, 5000)
            }
            if(checkSearch('remsExpanded')) {
                document.querySelector('.preheader__rems-btn').click(); //Desktop only
                blurEl();
            }
            if(checkSearch('submenuExpanded')) {
                document.querySelector('.nav__link.nav__link-btn').click(); //Desktop only
                blurEl();
            }
            if (checkSearch('submenuTwoExpanded')) {
                var submenuTwo = document.getElementById('submenuTwo');
                submenuTwo.removeAttribute('hidden');
                document.querySelector('.nav__link-btn.nav__link--other-resources').classList.add('nav__link--active');
                document.querySelector('.nav__link-btn.nav__link--other-resources').classList.add('hover');
                blurEl();
            }            
            if(checkSearch('mobileMenuExpanded')) {
                document.querySelector('.header__nav-btn').click(); //Mobile only
                blurEl();
            }
            if(checkSearch('hcpModal')) {
                document.getElementById('autoload-trigger').click();
                document.querySelector('body').classList.add('hcp-modal-open');
                document.querySelector('#hcpGateway-modal').style.position = 'absolute';
                setTimeout(() => {
                    blurEl();
                },1000);
            }
            if(checkSearch('hcpModalFull')) {
                document.querySelector('body').classList.add('hcpModalFull');
            }
            if(checkSearch('liaisonError')) {
                document.getElementById('submitLiaison').click();
                blurEl();
            }
            if(checkSearch('liaisonProcessingError')) {
                document.querySelector('.processing-error').classList.add('show');
                document.getElementById('findMedicalScienceLiaison').click();
                document.getElementById('zipCode').value = '90210';
            }
            if(checkSearch('liaisonMSL')) {
                document.getElementById('findMedicalScienceLiaison').click();
                document.getElementById('zipCode').value = '90210';
                document.getElementById('submitLiaison').click();
                blurEl();
            }
            if(checkSearch('liaisonMOVL')) {
                document.getElementById('findMedicalOutcomesLiaison').click();
                document.getElementById('zipCode').value = '90210';
                document.getElementById('submitLiaison').click();
                blurEl();
            }
            if(checkSearch('liaisonNoResults')) {
                document.getElementById('findMedicalScienceLiaison').click();
                document.getElementById('zipCode').value = '00000';
                document.getElementById('submitLiaison').click();
                blurEl();
            }
            if(checkSearch('expandResources')) {
                setTimeout(() => {
                    document.getElementById('asset-past-0').click();
                    blurEl();
                }, 1000);
            }
            if(checkSearch('congressBothIcons')) {
                setTimeout(() => {
                    document.querySelector('body').classList.add('custom-filter--single-result');
                    document.querySelector('.congress__counter--past span').innerText = '1';
                    document.querySelectorAll('.congress').forEach(c => {
                        c.hidden = true;
                    });
                    document.querySelector('.congress[data-congress-name="Canadian Society of Addiction Medicine (CSAM-SMCA) Annual Meeting"]').hidden = false;
                    document.querySelector('.congress[data-congress-name="Canadian Society of Addiction Medicine (CSAM-SMCA) Annual Meeting"] button').click();
                    document.querySelector('.load-more--past').hidden = true;
                    blurEl();
                }, 1000);
            }
            if(checkSearch('moreFilters')) {
                setTimeout(() => {
                    document.querySelectorAll('.filter-toggle').forEach(f => {
                        f.click();
                    }); //Mobile only
                    blurEl();
                }, 1000)
            }
            if(checkSearch('categoryDropdownAllChecked')) {
                setTimeout(() => {
                    document.querySelector('#categoryPast-button').click();
                    document.querySelectorAll('#categoryPast input[type="checkbox"]').forEach(checkbox => {
                        checkbox.checked = true;
                    });
                    blurEl();
                }, 1000);
            }
            if(checkSearch('categoryDropdownTwoChecked')) {
                setTimeout(() => {
                    document.querySelector('#categoryPast-button').click();
                    document.querySelectorAll('#categoryPast input[type="checkbox"]').forEach(checkbox => {
                        checkbox.checked = false;
                    });
                    const checkboxes = Array.from(document.querySelectorAll('#categoryPast input[type="checkbox"]'));
                    checkboxes.slice(0, 2).forEach(checkbox => {
                        checkbox.checked = true;
                    });
                    const selectedValues = checkboxes
                        .filter(x => x.checked)
                        .map(x => x.value)
                        .join(', ');
                    document.querySelector('#categoryPast-button span').innerHTML = selectedValues;
                    blurEl();
                }, 1000);
            }
            if(checkSearch('categoryDropdownClosed')) {
                setTimeout(() => {
                    document.querySelector('#categoryPast-button').click();
                    document.querySelector('#categoryPast-button span').innerHTML = Array.from(document.querySelectorAll('#categoryPast input[type="checkbox"]'))
                        .filter(x => x.checked)
                        .map(x => x.value)
                        .join(', ');
                    document.querySelector('#categoryPast-button').click();
                    blurEl();
                }, 1000);
            }
            if(checkSearch('congressNoResults')) {
                document.querySelector('body').classList.add('custom-filter');
                document.querySelectorAll('.congress-wrapper').forEach(c => {
                    c.setAttribute('hidden', true);
                });
                document.querySelectorAll('.congress-publication-bottom-controls').forEach(c => {
                    c.classList.add('hidden');
                });
                setTimeout(() => {
                    document.querySelectorAll('.congress__counter.congress__counter--past span, .congress__counter.congress__counter--upcoming span').forEach(c => {
                        c.innerText = '0';
                    });
                    blurEl();
                }, 1500);
                document.querySelectorAll('.congress__zero-results.congress__zero-results--past, .congress__zero-results.congress__zero-results--upcoming').forEach(c => {
                    c.removeAttribute('hidden');
                });
            }
            if(checkSearch('upcomingCongress')) {
                document.getElementById('tab-tabpanel-1').click();
                blurEl();
            }
            if(checkSearch('exitModal')) {
                document.getElementById('autoload-exit-trigger').click();
                document.querySelector('body').classList.add('exit-modal-open');
                document.querySelector('#exit-modal').style.position = 'absolute';
                blurEl();
            }
            if(checkSearch('exitModalFull')) {
                document.querySelector('body').classList.add('exitModalFull')
            }
            if(checkSearch('btodModal')) {
                document.getElementById('autoload-btod-trigger').click();
                document.querySelector('body').classList.add('btod-modal-open');
                document.querySelector('#btod-modal').style.position = 'absolute';
                blurEl();
            }
            if(checkSearch('btodModalFull')) {
                document.querySelector('body').classList.add('btodModalFull')
            }
            if(checkSearch('publicationNoResults')) {
                document.querySelector('.publication-wrapper').setAttribute('hidden', true);
                document.querySelector('.congress-publication-bottom-controls').classList.add('hidden');
                setTimeout(() => {
                    document.querySelector('.publication__counter').innerHTML = '<p>0 publication results</p>';
                }, 2000);
                document.querySelector('.publication__zero-results').setAttribute('hidden', false);
                blurEl();
            }
            if(checkSearch('expandResources')) {
                document.getElementById('asset-past-0').click();
                blurEl();
            }
            if(checkSearch('dataLoading')) {
                document.getElementById('findMedicalScienceLiaison').click();
                document.getElementById('zipCode').value = '90210';
                document.querySelector('[data-loading="false"]').setAttribute('data-loading', 'true');
                blurEl();
            }
            if(checkSearch('radioSelected')) {
                document.getElementById('findMedicalScienceLiaison').click();
                blurEl();
            }
        }
    })
}